import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as constants from '../../../constants-types/constants';
import { UserProfileSettingsService } from '../../../system-services/UserProfileSettings/UserProfileSettings.service';
import { TranslationService } from '../../../translations/Translation.service';
@Component({
    selector: 'list-pager-size-picker',
    template: `
        <div class="pi-pagination_resultsToggle">
            {{ TR.key('tablePager.resultsPerPage') }}
            @for (resultsCount of resultsPerPageOptions; track resultsCount) {
                <a
                    [ngClass]="{
                        'lsg-link': resultsPerPage !== resultsCount,
                        'lsg-link--disabled': resultsPerPage === resultsCount
                    }"
                    (click)="setResultsPerPage(resultsCount)"
                >
                    {{ resultsCount }}
                </a>
            }
        </div>
    `,
    standalone: false
})
export class ListPagerSizePickerComponent {
    @Input()
    resultsPerPage = constants.tableDefaultResultsPerPage;
    @Output()
    resultsSizeChange: EventEmitter<number> = new EventEmitter();

    resultsPerPageOptions = [
        constants.tableDefaultResultsPerPage,
        constants.serverApiMaxResults
    ];

    constructor(
        public TR: TranslationService,
        private userProfileSettings: UserProfileSettingsService
    ) {}

    setResultsPerPage(resultsPerPage: number): void {
        this.userProfileSettings.preferredPageSize = resultsPerPage;
        this.resultsSizeChange.emit(resultsPerPage);
    }
}
